<script setup lang="ts">
import type { CmsBlockProductListing } from "@shopware/composables";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockProductListing;
}>();

const { getSlotContent } = useCmsBlock(props.content);
const slotContent = getSlotContent("content");
</script>

<template>
  <div class="!m-0 h-full">
    <CmsGenericElement v-if="slotContent" :content="slotContent" />
  </div>
</template>
